module.exports = __webpack_public_path__ + "img/四川省骨科医院.0143c70e.png";